module.exports = __webpack_public_path__ + "static/img/ourAdvantage.7af7070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ourAdvantage.png
// module id = qEL2
// module chunks = 1